// TODO: Could get these from global settings
const DAYS_TO_ADD = 3;
const DAY_IF_TOO_LATE = 25;

export const getPaymentDay = (today: number) => {
  const desiredDay = today + DAYS_TO_ADD;

  if (desiredDay <= 28) {
    return desiredDay;
  }

  // If calculated payment day is after the 28th, choose the 25th;
  return DAY_IF_TOO_LATE;
};
